import { ApiClientResponseError } from "@verity/api-client";
import apiClient from "../../../helpers/api-client";

export const baseTransKey = "portal.components.uploadFilesTSX";
export const MAX_FILE_UPLOAD = 10;

export type FileUploadErrorCode = "UPLOAD_SIZE" | "UPLOAD_FAIL" | "MAX_FILES_EXCEEDED";

export class FileUploadError extends Error {
	constructor(
		public code: FileUploadErrorCode,
		message?: string,
	) {
		super(message);
		this.name = "FileUploadError";
	}
}

export async function uploadFileToS3(proctoringSessionId: string, file: File) {
	try {
		const mimeType = file.type;
		const fileName = file.name;
		const fileSize = file.size;

		const res = await apiClient.proctoringSession.getPublicAssessmentSubmissionUploadUrl({
			proctoringSessionUuid: proctoringSessionId,
			fileName,
			fileSize,
			mimeType,
		});

		const url = res.uploadUrl;

		const uploadResponse = await fetch(url, {
			method: "PUT",
			headers: {
				"Content-Type": file.type,
			},
			body: file,
		});
		if (!uploadResponse.ok) {
			throw new FileUploadError("UPLOAD_FAIL", `Failed to upload assessment resource: ${uploadResponse.statusText}`);
		}
	} catch (e) {
		if (e instanceof FileUploadError) throw e;
		if (e instanceof ApiClientResponseError) {
			if (e.status === 413) throw new FileUploadError("UPLOAD_SIZE");
			if (e.status === 422) throw new FileUploadError("MAX_FILES_EXCEEDED");
		}
		throw new FileUploadError("UPLOAD_FAIL");
	}
}
